import React from "react";
import BackButton from "../../BackButton";
import { ReactComponent as ArrowIcon } from "../../../inlineSvgs/arrow-left.svg";
import { NavLink } from "react-router-dom";

const BookingHead = () => {
  return (
    <div className="booking-head">
      <div className="left">
        <BackButton className="back-btn">
          <ArrowIcon />
        </BackButton>
        <div className="title">Create your ideal booking</div>
      </div>
      <div className="step-navigation">
        <NavLink className={"step-btn"} to="/booking/service">
          Select Service
        </NavLink>
        <NavLink className={"step-btn"} to="/booking/master">
          Select Master
        </NavLink>
        <NavLink className={"step-btn"} to="/booking/date">
          Select Date & Time
        </NavLink>
      </div>
    </div>
  );
};

export default BookingHead;
